export const STREAKS_TOOLTIPS = {
  played: 'Consecutive days without missing a daily',
  timeouts: 'Consecutive days without a timeout',
  scratches: 'Consecutive days with a score of 0 or better',
  parBirdieEagle:
    'Consecutive days with a par (or better), birdie (or better), AND eagle (or better)',
};
